import { render } from "./Job.vue?vue&type=template&id=4f1011e0"
import script from "./Job.vue?vue&type=script&lang=js"
export * from "./Job.vue?vue&type=script&lang=js"
script.render = render

export default script